import { gullakHomeDataAtom } from "@/store";
import { useAtom } from "jotai";
import { useGullakLogin } from "./use-gullak-login";
import { getGullakGuestHome, getGullakHome } from "../services";

export default function useGullakHomeData() {
  const [gullakHomeData, setGullakHomeData] = useAtom(gullakHomeDataAtom);
  const { isLogin } = useGullakLogin();

  const updateGullakHomeData = () => {
    const refetch = isLogin ? getGullakHome : getGullakGuestHome;
    return refetch().then((res) => {
      setGullakHomeData(res);
      return res;
    });
  };

  return {
    gullakHomeData,
    updateGullakHomeData,
  }

}